import { faSleigh, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Button, Container } from 'reactstrap';
import Sectionheader from '../../components/Admin/sectionHeader';
import Sharedheader from '../../components/Admin/sharedHeader';
import PagePath from '../../components/common/pagePath';
import "../../style/css/pro/Admin.css";
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Calender from '../../components/common/calender';
import Switch from '@mui/material/Switch';
import Footer from '../../components/common/global_layout/footer';
import httpClient from '../../httpClient';
import { Col,Row } from 'reactstrap';
import {
    faPlus,
    faUserCircle,
    faPen,
    faTrashAlt,
    faEdit,
    } from '@fortawesome/free-solid-svg-icons';


const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      '&:after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

class Profilesettings extends Component {
    constructor(props) {
        super(props);
        this.state ={
            emails : [],
            phones : [],
            docs : [],
            notifSms : false,
            notifMail : true,
            upload : true,
            modalSignup: false,
            fields: {name :'' ,email: '', password: '',sousAgent:'true'},
            sousAgentList:[]
        }
        this.toggleSignup = this.toggleSignup.bind(this);
        this.sousAgentItirator = this.sousAgentItirator.bind(this);
        this.sousAgentItirator();
    }
    
    

    handleAddEmail = () => {
        const emails = this.state.emails;
        this.setState({ emails: [...emails, <Email handler={() =>this.handleRemoveEmail(emails.length)} index={emails.length}/> ] });
      };
    
     handleRemoveEmail = (idx) => {
        const emails = this.state.emails;
          this.setState({ emails: emails.filter((email, index) => index !== idx) });
        
      };

      handleAddPhone = () => {
        const phones = this.state.phones;
        this.setState({ phones: [...phones, <Phone handler={() =>this.handleRemovePhone(phones.length)} index={phones.length}/> ] });
      };
    
     handleRemovePhone = (idx) => {
        const phones = this.state.phones;
          this.setState({ phones: phones.filter((phone, index) => index !== idx) });
        
      };


      handleAddDocs = () => {
        const docs = this.state.docs;
        this.setState({ docs: [...docs, <Doc upload={this.state.upload} uploadHandle={() =>this.setState({upload : false})} handler={() =>this.handleRemoveDocs(docs.length)} index={docs.length}/> ] });
      };
    
     handleRemoveDocs = (idx) => {
        const docs = this.state.docs;
          this.setState({ docs: docs.filter((doc, index) => index !== idx) });
        
      };

      
      componentDidUpdate() {
        this.sousAgentItirator();
      }
    
      toggleSignup() {
        this.setState({
          modalSignup: !this.state.modalSignup
        });
      }
    
      onInputChange(evt) {
            this.setState({
                fields: {
                    ...this.state.fields,
                    [evt.target.name]: evt.target.value
                }
            })
      }
      
    
      onFormSubmitSignup(evt) {
        evt.preventDefault()
            httpClient.signUp(this.state.fields).then(user => {
                this.setState({ fields: { name: '', email: '', password: ''} })
                if(user) {
                    this.props.onSignUpSuccess(user)
            this.setState({
              modalSignup:false
            });			}
            return 
        })
        }
      
      sousAgentItirator(){
        httpClient.getAgentsList().then(res=>{
          this.setState({
            sousAgentList: res,
          });
        }
        )
      }
      DesactiverSousAgent(evt){
        httpClient.ActiveInactive(evt.target.checked,evt.target.id);
      }
    render() {
        const {name , email, password } = this.state.fields
    const list = this.state.sousAgentList
        return (
            <>
                <Container className='mb-5 pb-5'>
                   <PagePath pages={['Acceuil', "Paramètres du compte"]}/>
                   <Sharedheader name="Paramètres du compte" icon="/imgs/dashboard/prof_set.svg"/>
                   <Sectionheader icon="/imgs/dashboard/login.svg" txt="Paramètres de Connexion" />
                   <div className='cnx__inputs container mt-4'>
                     <div>
                      <h6 className='prof__input__label'>E-mail de connexion</h6>
                      <input type="email" className='prof__input' placeholder='example@mail.com' />
                     </div>
                     <div className="other__mails mt-3">
                       <h6 className='prof__input__label'>Autres e-mails</h6>
                       <div className="emails__inputs">
                           <div className='d-flex align-items-center'>
                              <div className='d-flex'>
                                 {this.state.emails.map((item) =><div> {item}</div>)}
                              </div> 
                              <div>
                                  <img onClick={this.handleAddEmail} src="/imgs/dashboard/deposite_add.svg" className='add__email' alt="" />
                              </div>
                           </div>
                       </div>
                     </div>
                     <div className='mt-4'>
                      <h6 className='prof__input__label'>Mot de passe</h6>
                      <input type="password" className='prof__input prof__input__pass'  placeholder='im password' />
                     </div>
                     <div className='mt-4'>
                      <h6 className='prof__input__label'>Téléphone de connexion</h6>
                      <input type="tel" className='prof__input '  placeholder='+213 777 123 456' />
                     </div>
                     <div className="phone__inputs mt-4">
                           <h6 className='prof__input__label'>Autres numéros</h6>
                           <div className='d-flex align-items-center'>
                              <div className='d-flex'>
                                 {this.state.phones.map((item) =><div> {item}</div>)}
                              </div> 
                              <div>
                                  <img onClick={this.handleAddPhone} src="/imgs/dashboard/deposite_add.svg" className='add__email' alt="" />
                              </div>
                           </div>
                     </div>
                     <div className="prof__save d-flex justify-content-end mt-4 col-8">
                         <button className='save__btn'>Sauvegarder</button>
                     </div>
                   </div>
                   <Sectionheader icon="/imgs/dashboard/notif.svg" txt="Notifications" />
                   <div className='container mt-3'>
                       <div className="d-flex align-items-center">
                          <h6 className='prof__input__label mr-2 col-1 pl-1'>Par SMS</h6> 
                          <FormControlLabel
                             control={<Android12Switch defaultChecked={this.state.notifSms} />}
                             label=""/>
                       </div>
                       <div className="d-flex align-items-center">
                          <h6 className='prof__input__label mr-2 col-1 pl-1'>Par E-mail</h6> 
                          <FormControlLabel
                             control={<Android12Switch defaultChecked={this.state.notifMail} />}
                             label=""/>
                       </div>
                   </div>
                   <Sectionheader icon="/imgs/dashboard/docs.svg" txt="Mes Documents" />
                   <div className="container d-flex justify-content-between align-items-center">
                           <div className="phone__inputs mt-4 ">
                           <div className='d-flex align-items-center'>
                              <div className='d-flex'>
                                 {this.state.docs.map((item) =><div> {item}</div>)}
                              </div> 
                              <div>
                                  <img onClick={this.handleAddDocs} src="/imgs/dashboard/deposite_add.svg" className='add__email' alt="" />
                              </div>
                           </div>
                    </div>
                        <div className="profile__personnel d-flex flex-column  px-3 py-3 mb-2">
                             <h3>Faical Laroum</h3>
                             <span>ID Nombre : 000111222333</span>
                             <span>Permis C : 000000/21  -  Délivrée le 11/11/2011</span>
                             <span>Adresse : Bvd. Houari Boumedien. Bt 10. n°6. Skikda 21000</span>
                         </div>
                   </div>
                    <Sectionheader icon="" txt="Sous-agent" />
                    <div className='col-8 mt-4'>
           
               
                             <div className="sous-agent">
                               <Row>
                                 <Col xs="12">
                                 <div>
                             
                                   { 
                                    list &&
                                      this.state.sousAgentList.map(function (feature, i) {
                                        if(feature.sousAgent){
                                          return(   
                                            <div class="sous-agent-line" key={feature.Id}>
                                            <span className="sous-agent-nom">{feature.name}</span>
                                            <div className="edit-delete-sa">
                                            <input type="checkbox" hidden="hidden" value={feature._id} id={feature.name} defaultChecked={feature.sousAgentAcitveInAcitve&&"true"}
                                            onClick={(evt=>{
                                              httpClient.ActiveInactive(evt.target.checked,evt.target.value);
                                            })}
                                            />
                                             <label class="switch" for={feature.name}></label>
                                            <FontAwesomeIcon className="icon-small" icon={faPen} title="Edit"/>
                                            <FontAwesomeIcon className="icon-small"name={feature._id} id={i}  icon={faTrashAlt} title="Delete"
                                                    onClick={(evt=>{
                                                      var idAgent = document.getElementById(`${i}`).getAttribute("name")
                                                      httpClient.DeleteSousAgent(idAgent);
                                                    })} 
                                            />
                                            </div>
                                            </div>
                                            )
                                        }return ""})
                                     }
                                 </div>
                                 </Col>
                                 <Col xs="12">
                                 <div class="sous-agent-line">
                                       <span className="sous-agent-nom">Imad Mansour</span>
                                      <div className="edit-delete-sa">
                                            <input type="checkbox" hidden="hidden" id="imad" onClick={this.DesactiverSousAgent.bind(this)} />
                                             <label class="switch" for="imad"></label>
                                            <FontAwesomeIcon className="icon-small" icon={faPen} title="Edit"/>
                                            <FontAwesomeIcon className="icon-small" icon={faTrashAlt} title="Delete" />
                                      </div>
                                  </div>
                                 </Col>
                               </Row>
                             </div>
                             <Button className="button-underdiv" onClick={this.toggleSignup}>Ajouter</Button>
              
                        </div>
                   
                    <Sectionheader icon="/imgs/dashboard/account.svg" txt="Mon Compte"/>
                    <div className="account__settings mt-5 container">
                        <Button className='settings__btn d-flex align-items-center mb-2'>
                            <img src="/imgs/dashboard/desactiver.svg" className='sett__icon mr-2' alt="" />
                            <span>Désactiver temporairement</span>
                        </Button>
                        <p className='sett__txt mb-4'>Votre compte sera dépublié, mais il reste toujours sur notre plateforme, vous pourrez toujours le récupérer </p>
                        <Button className='settings__btn d-flex align-items-center mb-2 mt-2'>
                            <img src="/imgs/dashboard/delete__acc.svg" className='sett__icon mr-2' alt="" />
                            <span>Supprimer définitivement</span>
                        </Button>
                        <p className='sett__txt'>Votre compte sera supprimé de la plateforme Ghurfaty, vous ne pourriez pas récupérer vos informations
                          et vous aurez besoin de créer un nouveau compte pour utiliser Ghurfaty.</p>
                    </div>
                </Container>
                <Footer />
            </>
        );
    }
}

function Email(props) {
    return (
        <div className='mr-3'>
        <input index={props.index} type="email" className='prof__input ' placeholder='example@mail.com' />
        <FontAwesomeIcon icon={faTimes} onClick={props.handler}   className='delete__input'/>
        </div>
    )
}
function Phone(props) {
    return (
        <div className='mr-3'>
        <input index={props.index} type="tel" className='prof__input ' placeholder='+213 777 123 456' />
        <FontAwesomeIcon icon={faTimes} onClick={props.handler}   className='delete__input'/>
        </div>
    )
}
function Doc(props) {
    return (
        <div className='mr-3'>
            <input type="file" />
        </div>
    )
}

function Upload(props) {
    return (
        <div>
         
            
        </div>
    )
}

export default Profilesettings;
